import React from 'react';
import { MdClear } from 'react-icons/md';

function SearchBar({ value, placeholder, onChange }) {
    return (
        <div className='w-full flex items-center relative'>
            <input type='text' placeholder={placeholder ?? 'Cerca...'} className='w-full px-4 py-1 border border-gray-300 rounded-lg'
                value={value} onChange={(e) => onChange(e.target.value)} />
            {value !== '' && (
                <span className='absolute right-3 cursor-pointer' onClick={() => onChange('')}>
                    <MdClear size={20} />
                </span>
            )}
        </div>
    );
}

export default SearchBar;